<template>
   <div class="carrier-info">
    <div @click="goBack" class="backDiv" style="margin-top: 10px; margin-left: 10px;">
      <i class="pi pi-arrow-left"></i>
      <span> Carrier Information</span>
    </div>
    <div class="info-box">
      <div class="info-item">
        <strong>Carrier Name:</strong>
        <p>{{ carrierName }}</p>
      </div>
      <div class="info-item">
        <strong>Contact Name:</strong>
        <p>{{ contactName }}</p>
      </div>
      <div class="info-item">
        <strong>Email:</strong>
        <p>{{ email }}</p>
      </div>
      <div class="info-item">
        <strong>Phone:</strong>
        <p>{{ phone }}</p>
      </div>
      <div class="info-item">
        <strong>Physical Address:</strong>
        <p>{{ physicalAddress }}</p>
      </div>
      <div class="info-item">
        <strong>Mailing Address:</strong>
        <p>{{ mailingAddress }}</p>
      </div>
      <div class="info-item">
        <strong>Type of Hauling:</strong>
        <p>{{ haulingType }}</p>
      </div>
      <div class="info-item">
        <strong>Authority Type:</strong>
        <p>{{ authorityType }}</p>
      </div>
      <div class="info-item">
        <strong>Owner Name:</strong>
        <p>{{ contactName }}</p>
      </div>
      <div class="info-item">
        <strong>Owner DOB:</strong>
        <span v-if="!ownerDOB" style="color: red; font-size: 18px;">* </span><span v-if="!ownerDOB">(Please provide this info below)</span>
        <p v-if="ownerDOB">{{ ownerDOB }}</p>
      </div>
    </div>

    <div class="actions">
      <div class="change-text">
        <p class="change-request">Request Changes:</p>
        <p class="note">
          Please note that this does not initiate any changes to your current active policy.
        </p>
      </div>
      <textarea v-model="carrierChanges" type="text" placeholder="Please list the changes you wish to make" class="changes-input"/>
      <button class="done-button" @click="goToCoverageReview" :disabled="isButtonDisabled">Done! Go to Coverage Review <i class="pi pi-arrow-right"></i></button>
    </div>
  </div>
</template>

  <script>
 export default {
  name: 'CarrierChanges',
  data() {
    return {
      carrierName: '',
      contactName: '',
      email: '',
      phone: '',
      physicalAddress: '',
      mailingAddress: '',
      haulingType: '',
      authorityType: '',
      carrierChanges: '',
      ownerDOB: null
    };
  },
  computed: {
    isButtonDisabled() {
      return !this.carrierChanges || this.carrierChanges.trim().length === 0;
    }
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
      const contactInfo = data.contact_info[0];
      const address = data.address;

      this.carrierName = contactInfo.namedInsured || 'N/A';
      this.contactName = data.primary_contact || 'N/A';
      this.email = data.primary_email || 'N/A';
      this.phone = data.primary_phone || 'N/A';
      this.physicalAddress = `${address[1].street}, ${address[1].city}, ${address[1].state}, ${address[1].zip}`;
      this.mailingAddress = `${address[0].street}, ${address[0].city}, ${address[0].state}, ${address[0].zip}`;
      this.haulingType = data.hauling_type || 'N/A';
      this.authorityType = data.authority_type || 'N/A';

      if(data.drivers) {
        let drivers = data.drivers;
        drivers.forEach(driver => {
          if(driver.driver_name == this.contactName) {
            this.ownerDOB = driver.birth_date
          }   
        })
      } else {
        console.error('No Drivers in data');
      }

    } else {
      console.error('No data found in localStorage');
    }

    const carrierChangesCheck = localStorage.getItem('carrier_changes');
    if (carrierChangesCheck){
      console.log("changes exist in local");
      this.carrierChanges = carrierChangesCheck;
    } else {
      console.log("nothing exists");
    }


  },
  methods: {
    goToCoverageReview() {
      if (this.carrierChanges.trim()) {
        localStorage.setItem('carrier_changes', this.carrierChanges);
        this.$router.push('/coverageinfo');
      } else {
        this.showError = true;
      }
    },
    goBack() {
      // Store the current scroll position
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      // Set a flag in sessionStorage before navigation
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);

      // Navigate back
      this.$router.go(-1);
    }
  }
};
  </script>
  
  <style scoped>

i {
  margin-left: 10px;
}

.carrier-info {
  background-color: white;
  padding: 0px;
  margin: 0px;
  width: 100%;
  max-width: 800px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  text-align: left;
  border: 1px solid #ddd;
}

header {
  text-align: center;
  margin-bottom: 20px;
}

.logo {
  max-width: 150px;
  margin-bottom: 10px;
}

h2 {
  color: #333;
}

.steps {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.step {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  color: white;
  font-weight: bold;
}

.step.active {
  background-color: #004d40;
}

.section-title {
  color: #333;
  text-align: center;
  margin-bottom: 20px;
  font-weight: bold;
}

.info-box {
  padding: 5px 20px;
}

.info-item {
  padding: 10px 0;
  
}

.info-item:last-child {
  border-bottom: none;
}

.info-item strong {
  display: block;
  margin-bottom: 5px;
  color: #333;
}

.info-item p {
  margin: 0;
  color: #666;
}

.change-request {
  font-weight: bold;
  margin-top: 0px;
  margin-bottom: 8px;
}

.change-text {
  width: 90%;
}

.actions {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.note {
  color: #777;
  margin-top: 0px;
  margin-bottom: 8px;
}

.changes-input {
  width: 94%;
  padding: 10px;
  border: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 20px;
  box-sizing: border-box;
  height: 6em; /* Default height for larger screens */
}

@media (max-width: 768px) {
  .changes-input {
    height: 70px; /* Adjust this value for mobile screens */
  }
}

@media (max-width: 480px) {
  .changes-input {
    height: 120px; /* Adjust this value for smaller mobile screens */
  }
}

@media (min-width: 1000px) {
  .carrier-info {
    width: 550px !important;
  }
}
</style>